import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(theme => ({
  dialogContent: {
    padding: theme.spacing(2, 3, 3),
    '&:first-child': {
      paddingTop: theme.spacing(2),
    },
  },
  formStack: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
  fullWidthField: {
    width: '100%',
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: theme.spacing(1.5),
    marginTop: theme.spacing(3),
    paddingTop: theme.spacing(1),
  },
}))
